import React from "react";
import { IoSettingsSharp } from "react-icons/io5";

const ProductsSection = ({ data }) => {
  return (
    <>
      {data ? (
        <div className=" min-h-30 grid justify-center lg:grid-cols-[repeat(auto-fit,minmax(200px,1fr))] grid-cols-[repeat(auto-fit,minmax(180px,1fr))] lg:px-4 px-2 py-4 gap-3 items-stretch text-center">
          {data?.length === 0 && <>No Data Found</>}
          {data.map((item) => (
            <div
              key={item.id}
              className="p-2 lg:px-3 rounded-xl border-2  border-[#00ab4f] lg:max-w-64 "
            >
              <div className="h-26">
                <img
                  className="h-full mx-auto"
                  src={`https://api.hsagold.in${item.images}` || ""}
                  alt={item.part_description}
                />
              </div>
              <div className="flex flex-col items-start justify-start">
                <p className="font-bold text-[#00ab4f] uppercase my-2 leading-none text-start">
                  {item.part_description || ""}
                </p>
                <p className="text-start">
                  <span className="font-bold leading-none">OE No.: </span>
                  {item.oe_number || ""}
                </p>
                <p className="text-start">
                  <span className="font-bold leading-none">Part No.: </span>
                  {item.part_number || ""}
                </p>
                <p className="text-start">
                  <span className="font-bold leading-none ">Applicable: </span>
                  {item.suitable_for_application?.join(", ") || ""}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full min-h-30 p-4 flex items-center">
          <IoSettingsSharp className="animate-spin text-green-700 w-full text-2xl m-4" />
        </div>
      )}
    </>
  );
};

export default ProductsSection;
